import { AxiosResponse } from "axios";
import ApiResponse from "../models/ApiResponse";
import { SelectiveExportOptions } from "../models/test-series/TestSeriesExcelExport";
import Api from "./Api";

export type ResponseType = "arraybuffer" | "blob" | "document" | "json" | "text" | "stream";

class TestSeriesExcelExportApi {
  constructor(private api: Api) {}

  public getSelectiveExportOptions(testRequestId: string): ApiResponse<SelectiveExportOptions> {
    return this.api.get(`/test-request/test-plans/${testRequestId}/selective/options`);
  }

  public exportSelectionOfTestRequest(
    testRequestId: string,
    repetition: boolean,
    meanValue: boolean,
    standardDeviation: boolean,
    targetValue: boolean,
    testMethods?: number[],
    firstSubstrates?: number[],
    secondSubstrates?: number[],
    products?: number[],
    buildingActions?: number[],
    specimenTreatments?: number[],
    conditions?: number[],
  ): Promise<AxiosResponse<BlobPart>> {
    const arraybuffer: ResponseType = "arraybuffer";

    const params = new URLSearchParams([
      ["repetition", String(repetition)],
      ["meanValue", String(meanValue)],
      ["standardDeviation", String(standardDeviation)],
      ["targetValue", String(targetValue)],
    ]);

    if (testMethods) {
      testMethods.forEach((id) => params.append("testMethods", String(id)));
    }

    if (firstSubstrates) {
      firstSubstrates.forEach((id) => params.append("firstSubstrates", String(id)));
    }

    if (secondSubstrates) {
      secondSubstrates.forEach((id) => params.append("secondSubstrates", String(id)));
    }

    if (products) {
      products.forEach((id) => params.append("products", String(id)));
    }

    if (buildingActions) {
      buildingActions.forEach((id) => params.append("buildingActions", String(id)));
    }

    if (specimenTreatments) {
      specimenTreatments.forEach((id) => params.append("specimenTreatments", String(id)));
    }

    if (conditions) {
      conditions.forEach((id) => params.append("conditions", String(id)));
    }

    const config = {
      params,
      responseType: arraybuffer,
    };
    return this.api.get(`/test-request/test-plans/${testRequestId}/selective/matrixbasedexportall`, config);
  }
}

export default TestSeriesExcelExportApi;
